import { BackofficeCase } from "./BackofficeCase";
import PaymentRun from "./PaymentRun";
import { MediaObject } from "./MediaObject";

export enum PayerAccount {
  legalbirdMain = "legalbirdMainAccount",
  legalbirdRevenue = "legalbirdRevenueAccount",
  lbra = "lbraAccount",
}

export interface WireTransfer {
  id: number;
  recipientName: string | null;
  amount: number | null;
  subject: string | null;
  iban: string | null;
  typeOfPayment: string | null;
  reviewer: string | null;
  deletionReason: string | null;
  alternativeReviewer: string | null;
  caseId: number | null;
  createdBy: string | null;
  factualCorrectDate: string | null;
  factualCorrectBy: string | null;
  calculativeCorrectDate: string | null;
  calculativeCorrectBy: string | null;
  deletedDate: string | null;
  deletedBy: string | null;
  receipt: MediaObject | null;
  created: string | null;
  updated: string | null;
  backofficeCase: BackofficeCase | null;
  paymentRun?: PaymentRun;
  payerAccount: PayerAccount | null;
}
